import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

/**
 * [L11 P2] One-tap re-entry gate for a device that holds a stored return credential but no live
 * session. Name-less on purpose: the grant mirror is ids-only and this screen renders pre-auth
 * (a borrowed device must not flash the previous person's name). Continue hands the stored token to
 * the existing RedeemPage engine, which handles terms re-prompt / offline / a dead-token 404.
 */
export function WelcomeBackCard({ token, onUseDifferentCode }: { token: string; onUseDifferentCode: () => void }) {
  const navigate = useNavigate()
  return (
    <VStack py={12} px={6} gap={5} maxW="26rem" mx="auto" align="stretch">
      <Box>
        <Heading size="lg" mb={1}>Welcome back</Heading>
        <Text color="fg.muted">Pick up where you left off on this phone.</Text>
      </Box>
      <Button colorPalette="brand" minH="44px"
        onClick={() => navigate(`/canvasser/redeem?token=${token}`, { replace: true })}>
        Continue
      </Button>
      <Button variant="outline" minH="44px" onClick={onUseDifferentCode}>Use a different code</Button>
    </VStack>
  )
}
